import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import common from './modules/common';
import message from './modules/message';
import themeAndLanguage from './modules/themeAndLanguage';
import orgTree from './modules/orgTree';
import permission from './modules/permission';
import user from './modules/user';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    common,
    message,
    themeAndLanguage,
    orgTree,
    permission,
    user
  },
  getters
});

export default store;
